import { TIER_FEATURES, TIER_PRICES, type SubscriptionTier } from './constants';
import styles from '../SubscriptionPage.module.css';

interface PlanCardProps {
  tier: SubscriptionTier;
  isCurrentPlan: boolean;
  onUpgrade?: () => void;
  onManage?: () => void;
}

export function PlanCard({ tier, isCurrentPlan, onUpgrade, onManage }: PlanCardProps) {
  const isFree = tier === 'Free';
  const features = TIER_FEATURES[tier];
  const price = TIER_PRICES[tier];

  return (
    <div className={`${styles.planCard} ${!isFree ? styles.planCardPopular : ''}`}>
      <h3 className={styles.planName}>{tier}</h3>
      <div className={styles.planPrice}>
        <span className={styles.priceAmount}>${price}</span>
        <span className={styles.priceUnit}>/month</span>
      </div>
      <ul className={styles.featureList}>
        {features.map((feature, idx) => (
          <li key={idx} className={styles.featureItem}>
            <svg className={styles.checkIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            {feature}
          </li>
        ))}
      </ul>
      {isCurrentPlan ? (
        isFree ? (
          <button
            disabled
            className={`${styles.planButton} ${styles.planButtonCurrent}`}
          >
            Current Plan
          </button>
        ) : (
          <button
            onClick={onManage}
            className={`${styles.planButton} ${styles.planButtonSecondary}`}
          >
            Manage Subscription
          </button>
        )
      ) : !isFree ? (
        <button
          onClick={onUpgrade}
          className={`${styles.planButton} ${styles.planButtonPrimary}`}
        >
          Upgrade to {tier}
        </button>
      ) : (
        <button
          disabled
          className={`${styles.planButton} ${styles.planButtonDisabled}`}
        >
          Downgrade Unavailable
        </button>
      )}
    </div>
  );
}